import React from "react";

import { Slide } from "spectacle";
import { CustomHeading } from "../../../custom-style";

import {
  functionCode,
  classCode,
  moduleCode
} from "./code-examples/03-function-example";

export default () => {
  return (
    <Slide>
      <CustomHeading fit>¿Para qué sirven los Tests?</CustomHeading>
    </Slide>
  );
};



// WEBPACK FOOTER //
// ./src/slides/02-unit-testing/01-introduction/04-purpose-title.js